module.exports = __webpack_public_path__ + "img/logo-dark.c3566fb3.svg";